import { inject } from '@angular/core'

import { filter, take } from 'rxjs'

import { AUTH_SESSION } from '@ti/core/contracts/auth-session'
import { PUSH_CLIENT } from '@ti/core/contracts/push'

import { LOGIN_AS_SESSION } from '../contracts/login-as'
import { injectDestroy$ } from '../utils'

export class PushInitializer {
  protected readonly pushClient = inject(PUSH_CLIENT)
  protected readonly authSession = inject(AUTH_SESSION)
  protected readonly loginAsSession = inject(LOGIN_AS_SESSION, { optional: true })
  protected readonly destroy$ = injectDestroy$()

  public init() {
    this.authSession.state.currentUserAttributes$
      .pipe(
        filter((attr) => !!attr),
        take(1),
      )
      .subscribe(() => this.registerPushes())
  }

  protected async registerPushes() {
    if (this.loginAsSession) return

    try {
      const isRegistered = await this.pushClient.isRegistered()
      if (isRegistered) {
        await this.pushClient.subscribeToPushes()
      } else {
        await this.pushClient.register()
      }
    } catch (e) {
      console.warn('Failed to register pushes', e)
    }
  }
}
